<template>
  <side-bar
    v-show="isSidebarActiveLocal"
    position-right
    class="z-10 max-w25 mt-20"
  >
    <div class="flex sidebar-topfixpart bg-primary justify-between p-4">
      <h2 class="h2-class font-semibold text-white">EDIT PRODUCT</h2>

      <feather-icon
        icon="XIcon"
        @click="isSidebarActiveLocal = false"
        class="cursor-pointer text-white"
        svgClasses="w-6"
      ></feather-icon>
    </div>

    <div class="p-4 mb-8">
      <!-- <h2 class="mb-4 font-semibold text-base">Product Form</h2> -->

      <!-- <ProductForm /> -->
      <div class="mb-4">
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />
        <img
          v-if="image"
          :src="image.slice(0, 4) === 'data' ? image : `${$imageURL}/${image}`"
          ref="cover"
        />
        <div class="text-center text-red" v-if="image" @click="handleRemove">
          Remove image
        </div>
        <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>
      </div>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Product Name</p>
        <b-input v-model="name" placeholder="Enter Product Name..." required />
        <span v-if="nameErr" class="small text-danger">{{
          "Field is required"
        }}</span>
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Product description</p>
        <!-- <b-input-group prepend="Write Description" class="input-group-merge"> -->
        <b-form-textarea
          placeholder="Write Description..."
          v-model="description"
          required
        ></b-form-textarea
        ><span v-if="descErr" class="small text-danger">{{
          "Field is required"
        }}</span>
        <!-- </b-input-group> -->
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Brand</p>
        <!-- <b-input v-model="brand" placeholder="Enter Brand ..." required /> -->
        <!-- <label for="brand">Brand:</label> -->
        <multiselect
          name="brand"
          v-model="brand"
          :options="brandData"
          :multiple="false"
          :close-on-select="true"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Select Memberships"
          track-by="name"
          label="name"
          :preselect-first="false"
        >
        </multiselect>
      </div>

      <!-- <div class="mb-4">
        <p class="font-semibold text-sm mb-2">URL</p>
        <b-input
          v-model="url"
          placeholder="Enter URL ..."
          type="url"
          required
        />
        <span v-if="urlErr" class="small text-danger">{{
          "Field is required"
        }}</span>
      </div> -->
      <div class="mb-4">
        <input type="checkbox" id="checkbox-3" v-model="isURL" />
        <label>
          <strong class="mb-2 col-blk">Affiliate this product</strong></label
        >
        <p>
          <!-- <strong> <p class="col-blk">Affiliate this product</p></strong> -->
        </p>
        <!-- </input> -->
      </div>
      <template v-if="isURL == true">
        <div class="mb-4">
          <p class="font-semibold text-sm mb-2">URL</p>
          <b-form-input
            class="mb-2"
            alternative
            name="URL"
            :rules="{ required: true }"
            placeholder="Enter product URL"
            v-model="url"
          >
            <!-- <p>
              <strong> <p class="col-blk">Add URL</p></strong>
            </p> -->
          </b-form-input>
        </div>
      </template>
      <template v-if="isURL == false">
        <div class="mb-4">
          <p class="font-semibold text-sm mb-2">Stock Units</p>
          <b-input
            v-model="sku"
            type="number"
            placeholder="Enter Stock Units..."
          />
        </div>
      </template>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Coupon code</p>
        <b-input v-model="couponCode" placeholder="Enter Coupon code ..." />
        <span v-if="ccErr" class="small text-danger">{{
          "Field is required"
        }}</span>
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Price</p>
        <b-input
          v-model="price"
          placeholder="Enter Price ..."
          type="number"
          @change="handlePrice"
          required
        />
        <span v-if="priceErr" class="small text-danger">{{
          "Field is required"
        }}</span>
        <!-- @change="handleNumbers" -->
      </div>

      <!-- <div class="mb-4">
          <p class="font-semibold text-sm mb-2">Tags</p>
          <base-input class="div-mb-0">
            <select class="form-control ">
              <option disabled="">Select</option>
              <option>Summer</option>
              <option>Winter</option>
            </select>
          </base-input>
        </div> -->

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Discount %</p>
        <b-input
          v-model="discount"
          placeholder="Enter Discount"
          type="number"
          @change="handleDiscount"
        />
        <span v-if="discountErr" class="small text-danger">{{ msg.disc }}</span>
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Membership Discounts</p>
        <template v-for="(item, index) in get_all_membership">
          <label>{{ item.name }}</label>
          <b-input
            v-model="memberDisc[item.name]"
            placeholder="Enter Discount"
            type="number"
            @input="handleVals"
          />
        </template>
      </div>
    </div>

    <footer class="footer-fix fixed bottom-0 w-1/4">
      <base-button
        block
        type="primary"
        @click.prevent="onSubmit"
        class="rounded-none font-semibold"
        >SUBMIT</base-button
      >
    </footer>
  </side-bar>
</template>

<script>
// import "../../../scss/Index.scss";
import { mapState } from "vuex";

import FileUploader from "./FileUploader.vue";
import { max } from "moment";
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    editProductData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      showcategory: false,
      showproductform: false,
      isURL: false,
      sku: 0,
      name: "",
      description: "",
      url: "",
      brand: "",
      couponCode: "",
      price: 0,
      discount: 0,
      coverImage: null,
      image: null,
      imageErr: false,
      nameErr: false,
      descErr: false,
      urlErr: false,
      brandErr: false,
      ccErr: false,
      discountErr: false,
      priceErr: false,
      msg: {
        image: "",
        disc: "",
      },
      memberDisc: {},
    };
  },
  components: {
    FileUploader,
  },
  watch: {
    editProductData(val) {
      if (val && this.isSidebarActiveLocal) {
        this.init();
        this.get_all_membership.forEach((element, index) => {
          // console.log(this.editProductData);
          this.memberDisc[element.name] =
            this.editProductData.membershipDisc[element.name];
        });
      }
    },
  },

  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },

    ...mapState("affiliate", {
      brandData: "brandData",
    }),
    ...mapState("subscribe", {
      get_all_membership: "get_all_membership",
    }),
  },
  methods: {
    cbChnage() {
      // console.log(this.isURL);
    },
    handleVals(value) {
      // console.log(value);
    },
    handleDiscount(name, value) {
      this.discountErr = false;
      const newVal = Number(value.toString());
      this.discount = newVal;
      if (value <= 0) {
        this.discount = 0;
      }
    },
    handlePrice(value) {
      const newVal = Number(value.toString());
      this.price = newVal;
      if (value <= 0) {
        this.price = 0;
      }
    },
    handleName() {
      this.nameErr = false;
      if (!/^[a-zA-Z ]*$/.test(this.name)) {
        this.nameErr = true;
        this.msg.name = "Name should not be numeric value";
      }
    },
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;

        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    getAllProduct() {
      this.$emit("getAllProduct");
    },
    closeSideBar() {
      this.isSidebarActiveLocal = false;
    },
    async onSubmit() {
      let flag = false;
      let keyName = "";
      Object.keys(this.memberDisc).forEach((keys) => {
        if (
          (this.memberDisc[keys] !== null && this.memberDisc[keys] < 0) ||
          this.memberDisc[keys] > 100
        ) {
          flag = true;
          keyName = keys;
        }
      });
      if (flag) {
        this.$swal({
          text: `Enter valid Membership Discounts for ${keyName}`,
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
        });
        return;
      }
      // console.log(this.isURL);

      // if (this.coverImage === null) {
      //   this.$swal({
      //     text: "Please Add Image",
      //     // icon: "success",
      //     showCancelButton: false,
      //     confirmButtonColor: "#830c81",
      //   });
      //   return;
      // }
      this.nameErr = false;
      this.descErr = false;
      this.urlErr = false;
      this.brandErr = false;
      this.ccErr = false;
      this.priceErr = false;
      this.discountErr = false;
      this.name = this.name.trim();
      this.description = this.description.trim();
      if (this.isURL) this.url = this.url.trim();
      // this.brand = this.brand.trim();
      // if (this.couponCode !== " ") this.couponCode = this.couponCode.trim();

      // if (
      //   this.name === "" ||
      //   this.description === "" ||
      //   this.profession === "" ||
      //   this.relate === ""
      // ) {
      //   await this.$swal({
      //     // text: "please add title, description, date and Time",
      //     text: `Please enter all the required details!`,
      //     icon: "warning",
      //     showCancelButton: false,
      //     confirmButtonColor: "#830c81",
      //   });
      //   return;
      // }
      let discountPrice = this.price - (this.price * this.discount) / 100;
      const payload = new FormData();
      payload.append("productId", this.editProductData._id);
      if (this.name) payload.append("name", this.name);
      if (this.description) payload.append("description", this.description);
      if (this.brand) payload.append("brand", JSON.stringify(this.brand));
      if (this.couponCode) payload.append("couponCode", this.couponCode);
      if (this.price) payload.append("price", this.price);
      if (this.discount) payload.append("discount", this.discount);
      payload.append("discountPrice", discountPrice.toFixed(2));
      if (this.isURL === true) {
        payload.append("isURL", this.isURL);
        if (this.url) payload.append("url", this.url);
      } else if (this.isURL === false) {
        payload.append("sku", this.sku);
        payload.append("isURL", this.isURL);
      }

      if (this.coverImage && this.image.slice(0, 4) === "data") {
        // console.log("image updated");
        payload.append("productImage", this.coverImage);
      }
      payload.append("membershipDisc", JSON.stringify(this.memberDisc));

      let loader;
      try {
        // console.log(payload);
        loader = this.$loading();
        if (this.name == "") {
          this.nameErr = true;
        } else if (this.description == "") {
          this.descErr = true;
        } else if (this.brand == "") {
          this.brandErr = true;
        } else if (this.couponCode == "") {
          this.ccErr = true;
        } else if (this.price == "") {
          this.priceErr = true;
        } else if (this.discount == "") {
          this.discountErr = true;
          this.msg.disc = "Field is required";
        } else if (this.discount > 100 || this.discount < 0) {
          this.discountErr = true;
          this.msg.disc = "Enter a valid discount value";
        } else {
          const updateProduct = await this.$store.dispatch(
            "affiliate/updateProduct",
            payload
          );

          if (updateProduct.code === 200) {
            // console.log(updateProduct);
            this.getAllProduct();
            loader.close();
            this.closeSideBar();
            await this.$swal({
              text: "Your product has been successfully updated!!",
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#830c81",
            });

            this.name = "";
            this.description = "";
            this.url = "";
            this.brand = "";
            this.price = 0;
            this.discount = 0;
            this.coverImage = null;
            this.image = null;
          }
        }
        loader.close();
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },

    init() {
      this.name = this.editProductData.name;
      this.description = this.editProductData.description;
      this.url = this.editProductData.url;
      // this.brand = this.editProductData.brand;
      this.brandData.forEach((ele) => {
        if (this.editProductData.brand === ele._id) this.brand = ele;
      });
      this.image = this.editProductData.productImage;
      this.discount = this.editProductData.discount;
      this.couponCode = this.editProductData.couponCode;
      this.price = this.editProductData.price;
      this.isURL = this.editProductData.isURL;
      this.sku = this.editProductData.sku;
    },
  },
  async mounted() {
    await this.get_all_membership.forEach((element, index) => {
      this.memberDisc[element.name] = 0;
    });
  },
};
</script>
